// extracted by mini-css-extract-plugin
module.exports = {"Accordion":"Accordion_Accordion__zlrFy","Accordion_title":"Accordion_Accordion_title__1r19i"};